import { Grid, Paper, Button, Box } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import useReactHookForm from "hooks/useReactHookForm";
import ContentRight from "shared/molecules/content-right";
import { useEffect } from "react";
import { hasAtLeastOneValue, nl3LiveclassPackagesInitialValues, nl3LiveclassPackagesProperties, nl3LiveclassPackagesValidationSchema } from "./helper";
import { formatDateUtc } from "utils/time-util/utcIstTime";

export function Nl3LiveclassPackagesFilter({setSearchPayload,
  setPage,
  clearValuesTrigger}) {

  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    nl3LiveclassPackagesInitialValues,
    nl3LiveclassPackagesValidationSchema,
    "",
  );
  


  const handleSearch =()=>{
    const payload: any = {};

    // const searchName = watch("searchName");
    // if(searchName) payload.searchName=searchName;

    const batchId = watch("batchId");
    if(batchId) payload.batchId=batchId;

    const classId = watch("classId");
    if(classId) payload.classId=classId;

    const collegeId = watch("collegeId");
    if(collegeId) payload.collegeId=collegeId;

    const sectionId = watch("sectionId");
    if(sectionId) payload.sectionId=sectionId;

    const academicYearId = watch("academicYearId");
    if(academicYearId) payload.academicYearId=academicYearId;

    const streamId = watch("streamId");
    if(streamId) payload.streamId=streamId;

    const createdAt = watch("created_at");
    if (createdAt?.[0]) payload.createdFrom = formatDateUtc(createdAt[0]);
    if (createdAt?.[1]) payload.createdTill = formatDateUtc(createdAt[1], true);

    const updatedAt = watch("updated_at");
    if (updatedAt?.[0]) payload.updatedFrom = formatDateUtc(updatedAt[0]);
    if (updatedAt?.[1]) payload.updatedTill = formatDateUtc(updatedAt[1], true);
  
    setSearchPayload(payload);
    setPage(1);
  }

  const clearFilter = () =>{
    // setValue("searchName","");
    setValue("batchId","");
    setValue("classId","");
    setValue("collegeId","");
    setValue("sectionId","");
    setValue("academicYearId","");
    setValue("streamId","");
    setValue("created_at",[null, null]);
    setValue("updated_at",[null, null]);
    setSearchPayload({});
    setPage(1);
  }

  useEffect(()=>{
    clearFilter()
  },[clearValuesTrigger])

  return (
    //
    <div>
      <Paper elevation={2} sx={{ px: 2, pb: 3, pt: 3 }}>
        <Grid container spacing={2} alignItems="flex-end">
          <DynamicForm
            fields={nl3LiveclassPackagesProperties}
            control={control}
            errors={errors}
            watch={watch}
            setValue={setValue}
            getValues={getValues}
          />


          <Grid item xs={12} sm={12} md={6} lg={3} sx={{ ml: "auto" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 1,
                pb: 0.5,
              }}
            >
              <Button
                variant="contained"
                sx={{
                  width: "80px",
                  height: "40px",
                  cursor: "pointer",
                  textAlign: "center",
                }}
                onClick={clearFilter}
                disabled={
                  !hasAtLeastOneValue(watch(), [
                    "batchId",
                    "classId",
                    "collegeId",
                    "sectionId",
                    "academicYearId",
                    "streamId",
                    "created_at",
                    "updated_at",
                  ]) || Object.keys(errors).length > 0
                }
              >
                clear
              </Button>
              <Button
                variant="contained"
                sx={{
                  width: "80px",
                  height: "40px",
                  cursor: "pointer",
                  textAlign: "center",
                }}
                onClick={handleSearch}
                disabled={
                  !hasAtLeastOneValue(watch(), [
                    "batchId",
                    "classId",
                    "collegeId",
                    "sectionId",
                    "academicYearId",
                    "streamId",
                    "created_at",
                    "updated_at",
                  ]) || Object.keys(errors).length > 0
                }
              >
                search
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
}
